var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "VueSmartContainer", staticClass: "vue-smart-slider-container" },
    [
      _c(
        "div",
        {
          ref: "VueSmartSlider",
          staticClass: "vue-smart-slider",
          class: { disabled: _vm.disabled },
          style: { "max-width": _vm.width.toString().concat("px") },
        },
        [
          _c(
            "div",
            { ref: "VueSmartRail", staticClass: "vue-smart-slider-rail" },
            [
              _vm.propProcess
                ? _c("vue-smart-slider-process", {
                    attrs: {
                      transition: _vm.transition,
                      height: _vm.propRailHeight,
                      left: _vm.left,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                ref: "VueSmartControl",
                staticClass: "vue-smart-slider-control",
                style: {
                  left: _vm.left + "px",
                  top: _vm.handlePosition.top,
                  transition: _vm.transition,
                },
                on: {
                  mouseup: _vm.onControlMouseUp,
                  mousedown: _vm.onControlMouseDown,
                  touchend: _vm.onControlMouseUp,
                  touchstart: _vm.onControlMouseDown,
                },
              }),
              _vm._v(" "),
              _vm.propMarks.length
                ? _c("vue-smart-slider-marks", {
                    attrs: {
                      "prop-marks": _vm.propMarks,
                      "prop-width": _vm.width,
                      "prop-max": _vm.max,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.marker.length
                ? _c("vue-smart-slider-pips", {
                    attrs: {
                      marker: _vm.marker,
                      width: _vm.width,
                      max: _vm.max,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }